import * as React from 'react';
import { styles } from './styles';
import { DesignBucketLabel } from '../../../components/DesignBucketShell/components/DesignBucketLabel';
import { Checkbox } from '@joykit';
import { PrintSVG } from '../PrintSVG';
import { EcardSVG } from '../EcardSVG';

interface Props {
  checked: boolean;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
  value: string;
  label: string;
  title: string;
}

export class InviteCheckbox extends React.Component<Props> {
  getSVGForInvite = (type: string): React.ComponentType<any> => {
    switch (type) {
      case 'print':
        return PrintSVG;
      case 'ecard':
        return EcardSVG;
      default:
        return PrintSVG;
    }
  };

  SVG = this.getSVGForInvite(this.props.value);

  render() {
    const SVG = this.getSVGForInvite(this.props.value);

    return (
      <div className={`${styles.container} ${this.props.className}`}>
        <div>
          <DesignBucketLabel label={this.props.title} />
          <div className={styles.label}>
            <div className={styles.svgContainer}>
              <SVG />
            </div>
            <span>{this.props.label}</span>
            <Checkbox
              checked={this.props.checked}
              value={this.props.value}
              readOnly={true}
              data-section={'invites'}
              onChange={this.props.onClick}
            />
          </div>
        </div>
      </div>
    );
  }
}
